import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-power',
  templateUrl: './power.component.html',
  styleUrls: ['./power.component.scss']
})
export class PowerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
